import { jsxs as a, jsx as c } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import l from "./MenuItem.module.css.js";
import { MenuItemContainer as f } from "./MenuItemContainer.js";
import { useMenuItem as d } from "./useMenuItem.js";
import { Selected as u } from "../../../foundations/icons/Selected.js";
const p = i((e, t) => {
  const { selected: r = !1, children: m, className: o, ...s } = e, n = d(e, t);
  return /* @__PURE__ */ a(
    f,
    {
      as: "href" in s ? "a" : "button",
      className: o,
      ...n,
      children: [
        r && /* @__PURE__ */ c(u, { ariaLabel: "Selected", className: l.selectedIcon }),
        m
      ]
    }
  );
});
p.displayName = "MenuItem";
export {
  p as MenuItem
};
//# sourceMappingURL=MenuItem.js.map
